import { PUBLIC_ASSET_REVISIONS } from 'constants/global';
import { decodeUrlParams, objectToQueryString } from 'utils/url-params';

export function createClearRevisionUrl(location: { search: string; pathname: string }): string {
  const queryParams = decodeUrlParams(location.search);
  queryParams['revision'] = 'current';
  return `${location.pathname}?${objectToQueryString(queryParams)}`;
}

export function isPublicRevision(revision: string | null | undefined): boolean {
  return revision != null && (PUBLIC_ASSET_REVISIONS as Array<string>).includes(revision);
}

export function isAssetMismatch({
  requestedAssetRevision,
  initializedAssetRevision,
}: {
  requestedAssetRevision: string | null;
  initializedAssetRevision: string | null;
}): boolean {
  return (
    !!requestedAssetRevision &&
    !!initializedAssetRevision &&
    requestedAssetRevision !== 'current' &&
    `${requestedAssetRevision}` !== `${initializedAssetRevision}`
  );
}

export function isNewRevisionAvailable({
  availableAssetRevision,
  initializedAssetRevision,
  isPublic,
}: {
  availableAssetRevision: string | null;
  initializedAssetRevision: string | null;
  isPublic: boolean;
}): boolean {
  if (!isPublic) {
    return false;
  }
  return availableAssetRevision !== initializedAssetRevision;
}
